export const ERROR_MESSAGE = {
  VACANT_FIELD: "This field may not be blank.",
  INVALID_EMAIL: "Please input valid email address.",
};
